export default function filterWhiteSpace (obj) {
  // Json传参格式下，字符串类型的参数数据过滤参数前后空格
  if (typeof obj !== 'string') {
    Object.keys(obj).forEach(key => {
      if (obj[key] && typeof obj[key] === 'object') {
        if (obj[key] && obj[key] instanceof Array) {
          obj[key].map(item => {
            if (typeof item !== 'object') {
              if (typeof item === 'string') {
                item.trim()
              }
            } else {
              filterWhiteSpace(item)
            }
          })
        } else {
          filterWhiteSpace(obj[key])
        }
      } else {
        if (typeof obj[key] === 'string') {
          obj[key] = obj[key].trim()
        } else if (typeof obj[key] === 'number') {
          obj[key] = Number(String(obj[key]).trim())
        }
      }
    })
  }
  return obj
}



// WEBPACK FOOTER //
// ./src/common/filterSpace.js